import React from 'react'

// material ui
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'

// local components
import SelectLocation from './SelectLocation'
import DateSelection from './DateSelection'
import SelectProduct from './SelectProduct'
import GuestPass from './GuestPass'
import ConfirmationRequired from './ConfirmationRequired'
import { useAppSettings } from 'components/shared/SettingsProvider'

const CartProductForm = props => {
  const {
    camper,
    session,
    divider,
    // camperSession,
    cartProduct,
    camperSession,
    // cartForm,
    inputErrors // via withFormResults
  } = props

  const { enableReservationsByDay } = useAppSettings()

  const plan = cartProduct.plan
    ? camper.plans.find(p => p.id === cartProduct.plan.id)
    : null

  const { confirmed } = camper

  if (!plan && !confirmed) {
    return <ConfirmationRequired camper={camper} />
  }

  // display date selection UI when feature flag is enabled and location is selected
  const displayDateSelection =
    enableReservationsByDay && cartProduct && cartProduct.location

  // display product select UI if a location has been selected, and any selected
  // product is a retail product, BUT hide if reservations by day is enabled
  const displaySelectProduct =
    !displayDateSelection &&
    cartProduct &&
    cartProduct.location &&
    (cartProduct.product ? cartProduct.product.retail : true)

  // Always render SelectProduct to trigger product auto-selection, but hide UI when date selection is active
  const shouldRenderSelectProduct =
    cartProduct &&
    cartProduct.location &&
    (cartProduct.product ? cartProduct.product.retail : true)

  return (
    <Box my={2}>
      <SelectLocation
        camper={camper}
        cartProduct={cartProduct}
        session={session}
        camperSession={camperSession}
        locations={session.locations}
        inputErrors={inputErrors}
      />
      {displayDateSelection && (
        <DateSelection
          location={cartProduct.location}
          camper={camper}
          session={session}
          cartProduct={cartProduct}
          camperSession={camperSession}
          onToggleDate={props.onToggleDate}
        />
      )}
      {shouldRenderSelectProduct && (
        <SelectProduct
          camper={camper}
          plan={plan}
          session={session}
          location={cartProduct.location}
          cartProduct={cartProduct}
          camperSession={camperSession}
          inputErrors={inputErrors}
          account={props.account}
          hideUI={displayDateSelection}
        />
      )}
      {cartProduct && cartProduct.redeemablePasses.length > 0 && (
        <Box mt={2}>
          {cartProduct.redeemablePasses.map(redeemablePass => (
            <GuestPass
              key={redeemablePass.id}
              camper={camper}
              session={session}
              product={cartProduct.product}
              redeemablePass={redeemablePass}
            />
          ))}
        </Box>
      )}
      {divider && (
        <Box pt={2}>
          <Divider />
        </Box>
      )}
    </Box>
  )
}

export default CartProductForm
